import React from 'react';
import _ from 'lodash';

import { ImportCsvModal } from 'iron-forge-react-modules';
import * as importCsvSettings from './importCsvSettings';
import * as dataService from './dataService';
import * as types from './types';



const ImportCsvModalComponent = ImportCsvModal.genComponent<types.NetSuiteShipItemsPropertyName>();

export interface IProps {
  onCancel: () => void;
  onAccept: () => void;
}

export const FC: React.FC<IProps> = props => {
  const tuple = dataService.useQuery();

  const [importNetSuiteShipItemsFromCsv, importNetSuiteShipItemsFromCsvTuple] = dataService.useImportNetSuiteShipItemsFromCsv();

  const processImport = React.useCallback(
    async (rows: Array<_.Dictionary<string>>) => {
      importNetSuiteShipItemsFromCsv(rows, tuple.data);
    },
    [
      importNetSuiteShipItemsFromCsv,
      tuple.data
    ]
  );

  const loading = tuple.loading || importNetSuiteShipItemsFromCsvTuple.loading;

  return (
    <ImportCsvModalComponent
      isOpen
      isLoading={loading}
      title="Import Net Suite Ship Items"
      columnDescriptions={tuple.data.columnDefs}
      formatType2Comment={importCsvSettings.propertyName2Comment}
      formatType2Data={importCsvSettings.propertyName2Data}
      fnImport={processImport}
      onCancel={props.onCancel}
      onAccept={props.onAccept} />
  );
};
